import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { APIBaseService } from "./api_base.service";
import { domain } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CustomerAPI extends APIBaseService {
  namespace = "profile";
  

  async profile() {
    const url = `${domain}/${this.namespace}/get`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async requestTopUpCredit(data) {
    const url = `${domain}/${this.namespace}/requestTopUpCredit`;
    return this.http.post(url, data ,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async requestTopUpPaynow(data) {
    const url = `${domain}/${this.namespace}/requestTopUpPaynow`;
    return this.http.post(url, data ,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async queryTopUp(data) {
    const url = `${domain}/${this.namespace}/queryTopUp`;
    return this.http.post(url, data ,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async deviceTokenRegister(data) {
    const url = `${domain}/${this.namespace}/deviceTokenRegister`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }}
